module.exports = __webpack_public_path__ + "b9864dcf0ed2d2456a1787a64cfaaf75.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/FO.svg
// module id = ypHJ
// module chunks = 0